import {usePartnerUi} from "~/contexts/PartnerUiContext";
import {InputUtils} from "@bounce/shared";
import {CustomMenuItem} from "@bounce/shared/consumer/components";
import React from "react";
import {Colors, IconDocument, IconLitigation, IconMarker} from "@bounce/shared/ui";
import {useExternalLinksOptions} from "./hooks/useExternalLinksOptions";

const ExternalLinkOptions = () => {
  const {partnerDetails} = usePartnerUi();
  const {shouldDisplayExternalLinksOptions, handleExternalLink, onTermsAndConditionsClick, onStateNoticeClick, onNMLSClick} =
    useExternalLinksOptions();
  const partnerLinks = partnerDetails?.links;

  if (!shouldDisplayExternalLinksOptions) return null;

  if (partnerLinks) {
    return (
      <>
        {Object.entries(partnerLinks).map(([title, url]) => (
          <CustomMenuItem
            key={title}
            label={InputUtils.prettierSnakeCaseSentence(title)}
            icon={<IconDocument size={20} color={Colors.primary._800} />}
            onClick={handleExternalLink(title, url)}
          />
        ))}
      </>
    );
  }

  return (
    <>
      <CustomMenuItem
        label="Terms and Conditions"
        icon={<IconDocument size={20} color={Colors.primary._800} />}
        onClick={onTermsAndConditionsClick}
      />
      <CustomMenuItem
        label="Notices and Disclosures"
        icon={<IconMarker width={20} height={20} />}
        onClick={onStateNoticeClick}
      />
      <CustomMenuItem label="State Licenses" icon={<IconLitigation width={20} height={20} />} onClick={onNMLSClick} />
    </>
  );
};

export default ExternalLinkOptions;
